import type { EntityType } from '@communities/content-management/domain';
import { WorkflowType } from '@communities/content-management/domain';
import { isCommunity } from '@communities/content-management/utils';
import { TabNavigation as CoreTabNavigation } from '@core/components/TabNavigation';

import { ClassificationTab } from './ClassificationTab';
import { CommunityContextTab } from './CommunityContextTab';
import { IdentityAccessTab } from './IdentityAccessTab';

interface TabNavigationProps {
  isEntityAdmin: boolean;
  entityId: string;
  entityType: EntityType;
  onEditCommunity?: () => void;
}

export function TabNavigation({ entityId, entityType, isEntityAdmin, onEditCommunity }: TabNavigationProps) {
  const tabs = [
    {
      key: 'identity-access',
      label: 'Identity & Access',
      content: <IdentityAccessTab entityId={entityId} entityType={entityType} isEntityAdmin={isEntityAdmin} workflowType={WorkflowType.CLASSIFICATION} />,
    },
    // Only show Community Context tab for communities, not community groups
    ...(isCommunity(entityType)
      ? [
          {
            key: 'community-context',
            label: 'Community Context',
            content: <CommunityContextTab entityId={entityId} isEntityAdmin={isEntityAdmin} onEditCommunity={onEditCommunity} />,
          },
        ]
      : []),
    {
      key: 'classification',
      label: 'Classification',
      content: <ClassificationTab entityId={entityId} entityType={entityType} isEntityAdmin={isEntityAdmin} workflowType={WorkflowType.CLASSIFICATION} />,
    },
  ];

  return (
    <CoreTabNavigation
      ariaLabel={`${isCommunity(entityType) ? 'Community' : 'Community group'} management sections`}
      defaultActiveTab="identity-access"
      tabs={tabs}
    />
  );
}
